const data = {

  Empathy : {

  abilities: ["Team formation",
      "Explore the problem and Understand the design challenge",
      "Map the social context"
  ],

  // Category 1: Team formation
  0: {
    skills: [
      "Scope the problem",
      "Form teams and establish roles within team",
      "Set tasks, timelines, and milestones within the team",
      "Plan general objectives and approaches of the project"
    ],
    knowledge: [
      "Cognition of research methods",
      "Cognition of team dynamics",
      "Cognition of managing time & budget resources",
      "Cognition of project management"
    ],
    mindset: [
      "Motivated to begin new projects",
      "Team player",
      "Perform under pressure",
      "Work independently"
    ],
    tools: [
      "Ice breakers",
      "Videography",
      "Site Analysis"
    ]
  },
  
  // Category 2: Explore the problem and Understand the design challenge
  1: {
    skills: [
      "Communicate & engage with the user",
      "Communicate & engage with the stakeholders",
      "Systems thinking",
      "Quantitative data analysis and interpretation",
      "Qualitative data analysis and interpretation"
    ],
    knowledge: [
      "Cognition of design frameworks, processes",
      "Cognition of business communication",
      "Cognition of identifying relationships between systems",
      "Cognition of quantitative analysis methods",
      "Cognition of qualitative analysis methods"
    ],
    mindset: [
      "Open to learning new ideas",
      "Sensitive to different personal backgrounds",
      "Curious and inquisitive",
      "Passionate with information",
      "Optimistic at finding insights",
      "Empathy"
    ],
    tools: [
      "Contextual Needs Analysis",
      "User Needs Analysis",
      "Multisensory Analysis",
      "User Journey Map",
      "Site Analysis",
      "User Interviews"
    ]
  },
  
  // Category 3: Map the social context
  2: {
    skills: [
      "Transdisciplinary Thinking",
      "Systems thinking",
      "Analyze the socio-economic context",
      "Analyze the Socio-historical context",
      "Identify socio-historical constraints & requirements",
      "Identify socio-cultural constraints & requirements"
    ],
    knowledge: [
      "Cognition of concepts outside one's field of expertise",
      "Cognition of evaluating relationships between disciplines",
      "Cognition of socio-economic principles",
      "Cognition of socio-historical fundamentals",
      "Cognition of contextual historical facts",
      "Cognition of concepts of equity and equality"
    ],
    mindset: [
      "Think beyond one's area of study",
      "Think globally",
      "Interest in societies",
      "Sensitive to the human condition",
      "Imaginative & explorative",
      "Communicative",
      "Empathy"
    ],
    tools: [
      "Scenarios",
      "Semantic Inquiry",
      "User's Interviews",
      "Emphatic Lead User",
      "Personas",
      "Shadowing"
    ]
  },
  
  // Category 4: Define the problem (placeholder for future data)
  defineproblem: {
    skills: [],
    knowledge: [],
    mindset: [],
    tools: []
  }
  },

  Define : {
    abilities: [
      "Define the problem"
    ],

    0: {
      skills: [
        "Derive Socio-cultural-historical requirements & constraints",
        "Derive requirements & constraints from literature.",
        "Derive user requirements & constraints.",
        "Derive stakeholders constraints.",
        "Identify and formulate the problem.",
        "Formulate the value proposition."
      ],
      knowledge: [
        "Cognition of humanities and social science concepts.",
        "Cognition of available state of the art solutions.",
        "Cognition of ethical principles.",
        "Cognition of business strategy & agile innovation.",
        "Cognition of problem statement preparation.",
        "Cognition of agile innovation."
      ],
      mindset: [
        "Empathetic to different views",
        "Detail oriented.",
        "Business acumen.",
        "Passionate about innovation.",
        "Communicative."
      ],
      tools: [
        "Personas.",
        "Activity Diagram.",
        "Affinity Diagram.",
        "Influence Diagram.",
        "System Model/Funcional Model.",
        "House of Quality/Quality Function Deployment.",
        "Hierarchy of Purpose.",
        "AEIOU.",
        "How Might We.",
        "Benchmarking",
        "Reframing"
      ]
    }
  },

  Ideate : {
    abilities: [
      "Mathematical design",
      "Physics design",
      "Computational design",
      "Materials design",
      "Sustainable design",
      "Ethics design",
      "Transdisciplinary design",
      "User-centric design",
      "AI Design",
      "Machine learning design",
      "Systems thinking design",
      "Generate ideas and concepts",
      "Represent ideas and concepts"
    ],

    // Category 5: Mathematical design
    0: {
      skills: [
        "Compute derivatives",
        "Optimize and interpret results",
        "Compute exact integration",
        "Apply numerical integration",
        "Solve differential equations",
        "Optimize mathematical systems",
        "Mathematical modelling"
      ],
      knowledge: [
        "Cognition of physical meaning of derivatives",
        "Cognition of algebra principles",
        "Cognition of rules of derivatives",
        "Cognition of integration techniques",
        "Cognition of types of differential equations",
        "Cognition of single and multivariable functions",
        "Cognition of partial derivatives"
      ],
      mindset: [
        "Numerical minded",
        "Mental dexterity"
      ],
      tools: [
        "Excel",
        "MatLab",
        "GeoGebra Suite"
      ]
    },

    // Category 6: Physics design
    1: {
      skills: [
        "Working principles of various technologies",
        "Compute magnetic fields",
        "Compute electric current sources",
        "Translate electromagnetism into circuit analysis",
        "3D Printing of prototypes",
        "Build circuits"
      ],
      knowledge: [
        "Cognition of electromagnetism",
        "Cognition of Maxwell's equation",
        "Cognition of quantum physics",
        "Cognition of Newtonian mechanics",
        "Cognition of Ohm's law",
        "Cognition of Kirchoff's law",
        "Cognition of 3D Printing techniques"
      ],
      mindset: [
        "Scientific thinking",
        "Interest in modern technologies",
        "Logic-oriented"
      ],
      tools: [
        "Solidworks",
        "Fusion360",
        "Curia 2.0",
        "Inventor",
        "Multipurpose meter",
        "Soldering gun",
        "Free body diagrams"
      ]
    },

    // Category 7: Computational design
    2: {
      skills: [
        "Visual and textual programming concepts",
        "Python programming to solve computational problems",
        "Develop artefacts for computional processes",
        "Create 3D models and/or renditions",
        "Programming for Raspberry Pi microcontroller",
        "Programme basic neural networks",
        "Apply machine learning techniques"
      ],
      knowledge: [
        "Cognition of visual and textual programming",
        "Cognition of Python programming",
        "Cognition of computational thinking approaches",
        "Cognition of computational geometry concepts",
        "Cognition in programming Raspberry Pi microcontroller",
        "Cognition of AI and machine learning techniques"
      ],
      mindset: [
        "Computational thinking",
        "User-oriented"
      ],
      tools: [
        "Rhinoceros 3D (Rhino CAD)",
        "Grasshopper CAD",
        "Jupyter Notebook",
        "Canva",
        "Figma",
        "Web design",
        "Roboflow"
      ]
    },

    // Category 8: Materials design
    3: {
      skills: [
        "Recognize various crystal structures of materials",
        "Recognize various types of polymer based on properties",
        "Identify the tensile strength of materials",
        "identify the elasticity of materials",
        "Recognize the thermal expansion of materials"
      ],
      knowledge: [
        "Cognition of atomic structure in materials",
        "Cognition of biodegradable materials",
        "Cognition of Hooke's law",
        "Cognition of combine loading",
        "Cognition of stress transformation"
      ],
      mindset: [
        "Materials classification",
        "Tensile strength of materials",
        "Strain & stress of materials",
        "Logic-oriented"
      ],
      tools: [
        "X-ray diffraction",
        "Phase diagrams",
        "Young's modulus",
        "Miller indices",
        "Griffith's energy criteria"
      ]
    },

    // Category 9: Sustainable design
    4: {
      skills: [
        "Recognize the human impact on local and global environment",
        "Identify physical & chemical properties of design materials",
        "Apply principles of responsible energy consumption",
        "Apply principles of responsibable water consumption",
        "Create life cycle analysis (LCA) of products",
        "Apply principles of alternative energy technologies in design",
        "Evaluate human activity impact on land and sea"
      ],
      knowledge: [
        "Cognition of human impact on local and global environment",
        "Cognition of physical and chemical properties of materials",
        "Cognition of science behind renewable energy",
        "Cognition of wastewater treatment",
        "Cognition of life cycle assessment of products",
        "Cognition of emergent technologies",
        "Cognition of biodiversity"
      ],
      mindset: [
        "Sustainability in design",
        "Awareness of human activity on planet",
        "Embrace of nature",
        "Responsible consumption",
        "Biodegradable materials"
      ],
      tools: [
        "Life Cycle Analysis (LCA)",
        "Energy footprint",
        "Water footprint"
      ]
    },

    // Category 10: Ethics design
    5: {
      skills: [
        "Identify all stakeholders' value priorities",
        "Map all stakeholders' concerns",
        "Find common ethical ground with all stakeholders",
        "Recognize and de-construct the scripts of existing designs",
        "Uncover underlying intentions and world-views",
        "Set ethical terms at the start of a project",
        "Identify potential unethical situations with a design",
        "Articulate areas of responsibility and non-responsibility for the design"
      ],
      knowledge: [
        "Cogntion of communicating ethical standpoints to stakeholders",
        "Cognition of translating values to concerns",
        "Cognition of value negotiation",
        "Cogniton of exploring creating solutions to moral problems",
        "Cognition of cultural ethos",
        "Cognition of normative ethical theories (virue ethics, deontology, consequentialism)",
        "Cognition of recognizing the ethical dimensions of designs"
      ],
      mindset: [
        "Ethical design",
        "Responsible design"
      ],
      tools: [
        "Moral value map",
        "Ethical contract",
        "De-scription (what, how, why)",
        "Ethical disclaimer",
        "Moral agent",
        "Normative design scheme"
      ]
    },

    // Category 11: Transdisciplinary design
    6: {
      skills: [
        "Synthesize ideas and concepts from different domains",
        "Synthesize technologies from different fields",
        "Merge ideas and concepts to create a new whole",
        "Co-create with stakeholders",
        "Determine stakeholder's needs via observations and interviews"
      ],
      knowledge: [
        "Cognition of content from different disciplines",
        "Cognition of perspectives from different disciplines",
        "Cognition of transdisciplinary ideas and concepts",
        "Cognition of observations, interviews, and other methods",
        "Cognition of domain jargon and terminology",
        "Cognition of exploring state of the art solutions"
      ],
      mindset: [
        "Open to new ideas",
        "Open to merging ideas",
        "Receptive to state of the art solutions"
      ],
      tools: [
        "Design narrative"
      ]
    },

    // Category 12: User-centric design
    7: {
      skills: [
        "Provide solutions according to customer requirements",
        "Develop solutions according to user needs",
        "Support the design of user interfaces (UI/UX/CX)",
        "Apply technologies on the cloud, mobile, and wearable devices",
        "Establish requirements for applying HCI in design",
        "Develop Personas from requirements",
        "Create Scenarios to express UI abstractions for design",
        "Design and develop a prototype using AI addressing HCI problems"
      ],
      knowledge: [
        "Cognition of fundamental concepts in human computer interactions (HCI)",
        "Cogntion of fundamental relationships between HCI and AI",
        "Cognition of advantages, disadvantages, and limintations of HCI",
        "Cognition of interaction design principles and human performance",
        "Cognition of observations, interviews, and other methods"
      ],
      mindset: [
        "User-oriented",
        "Customer-oriented",
        "Tech-savvy"
      ],
      tools: [
        "Figma",
        "Personas",
        "Scenarios"
      ]
    },

    // Category 13: AI Design
    8: {
      skills: [
        "Apply design ontology to formualte design representations",
        "Identify data sources for AI implementation",
        "Extract design keywords from textual data through programming",
        "Use natural language processing (NPL) to formulate design requirements",
        "Propose and evaluate design solutions using Generative Design CAD tools"
      ],
      knowledge: [
        "Cognition of formulating design repesentations of a given design task",
        "Cognition of identifying data sources for analysis",
        "Cognition of extracting actionable knowledge from data sources",
        "Cogntion of using AI techniques to identify design requirements",
        "Cognition of AI techniques to generate design solutions"
      ],
      mindset: [
        "Tech-savvy",
        "Open to change",
        "AI-savvy"
      ],
      tools: [
        "Python",
        "Javescript",
        "NLP",
        "CAD"
      ]
    },

    // Category 14: Machine learning design
    9: {
      skills: [
        "Choose appropriate algorithms for a variety of problems",
        "Implement regularized regression algorithms",
        "Implement unsupervised algorithms for clustering",
        "Implement algorithms for learning Bayesian networks",
        "Implement support vector machines algorythms",
        "Implement reinforcement learning algorthms"
      ],
      knowledge: [
        "Cognition of supervised, semi-supervised, and unsupervised algorithms",
        "Cognition of cross-validation and regularization and uses thereof",
        "Cognition of neural networks learning non-linear functions",
        "Cognition of the foundation of generative models"
      ],
      mindset: [
        "Tech-savvy",
        "Open to change",
        "Machine learning-savvy"
      ],
      tools: [
        "Logistic regression",
        "Neural networks",
        "Clustering",
        "Probabilistic graphical models",
        "SVM"
      ]
    },

    // Category 15: Systems thinking design
    10: {
      skills: [
        "Examine interactions of components within systems",
        "Examine how parts relate to one another",
        "Evaluate interdepencies within systems",
        "Drive strategic alignments of systems and processes",
        "Align systems across functional teams",
        "Align processes across functional teams",
        "Apply systems thinking to design requirements"
      ],
      knowledge: [
        "Cognition of systems archetypes",
        "Cognition of chaos theory",
        "Cognition of diagnostic tools for change management",
        "Cognition of computer simulation tools",
        "Cognition of applying systems thinking to design"
      ],
      mindset: [
        "Holistic thinking",
        "Tech-savvy",
        "Open to change"
      ],
      tools: [
        "Mind maps",
        "Concept maps",
        "Map systems",
        "Mental models"
      ]
    },

    // Category 16: Generate ideas and concepts
    11: {
      skills: [
        "Generate a wide range of ideas and concepts",
        "Propose a wide range of ideas and concepts",
        "Communicate within the team",
        "Communicate ideas and concepts verbally with coherence",
        "Communicate pictorially through 2D visuals",
        "Communicate spatially through 3D visuals",
        "Explore and expand the design space",
        "Apply co-creation strategies"
      ],
      knowledge: [
        "Cognition of methods and techniques to generate ideas and concepts",
        "Cognition of frameworks and tools to generate ideas and concepts",
        "Cognition of legal and corporate requirements",
        "Cognition of policies governing design practices",
        "Cognition of verbal communication methods and techniques",
        "Cognition of visualization methods and techniques",
        "Cognition of design heuristics and principles",
        "Cognition of co-creation strategies"
      ],
      mindset: [
        "Out-of-the-box thinking",
        "Generate many ideas and concepts",
        "Communicate ideas and concepts",
        "Visualzie ideas and concepts",
        "Open to criticism and feedback",
        "Willing to share ideas with the team"
      ],
      tools: [
        "Parallel sketching",
        "C-sketch",
        "Co-creation",
        "Mind mapping",
        "Customer journey mapping",
        "Morph matrix",
        "PSS (product-service-system design)",
        "Design by analogy (wordtree method)",
        "TRIZ"
      ]
    },

    // Category 17: Represent ideas and concepts
    12: {
      skills: [
        "Giving ideas and concepts aesthetic form and function",
        "Represent ideas and concepts through 2D visuals",
        "Represent ideas and concepts through 3D visuals",
        "Transform ideas and concepts from 2D to 3D and viceversa"
      ],
      knowledge: [
        "Cognition of methods and techniques to represent function",
        "Cognition of frameworks and tools to represent processes",
        "Cognition of methods and techniques to create 2D visuals",
        "Cognition of methods and techniques to create 3D visuals",
        "Cognition of spatial thinking"
      ],
      mindset: [
        "Creative in representing ideas and concepts",
        "Trust-worth in presenting ideas and concepts",
        "Artistic thinking",
        "Scientific thinking"
      ],
      tools: [
        "Real? Win? Worth it?",
        "Pugh Chart"
      ]
    }
  },

  Prototype : {

    abilities: [
      "Concretize the design",
      "Simulate the solution",
      "Prototype the solution"
    ],
  
    // Category 1: Concretize the design
    0: {
      skills: [
        "Develop the functions according to technical specifications",
        "Optimize the number of components based on functions",
        "Develop the form in compliance with conceptual design",
        "Select and apply appropriate design guidelines",
        "Identify resources and cost drivers",
        "Identify urgency, lead times, and priorities"
      ],
      knowledge: [
        "Cognition of developing a design concept into a solution",
        "Cognition of systems and systems thinking",
        "Cognition of modular design",
        "Cognition of design for manufacturing and assembly",
        "Cognition of production processes",
        "Cognition of design guidelines (DfX)",
        "Cognition of design standards and specifications"
      ],
      mindset: [
        "Strategic in planning",
        "Committed to a task",
        "Ready to experiment",
        "Manage information effectively",
        "Willing to work with others",
        "Diligent working under pressure"
      ],
      tools: [
        "Risk Management Process",
        "Mockups"
      ]
    },
    
    // Category 2: Simulate the solution
    1: {
      skills: [
        "Identify the intended functions of the simulation",
        "Simulate elements of the design",
        "Simulate to design products",
        "Simulate to modify materials",
        "Simulate to optimize processes",
        "Simulate to evaluate design alternatives",
        "Simulate/construct visual representation of data"
      ],
      knowledge: [
        "Cognition of models and functions",
        "Cognition of methods and techniques to simulate",
        "Cognition of analytical methods to simulate",
        "Cognition of modelling frameworks to simulate",
        "Cognition of processes to simulate",
        "Cognition of analysis criteria, metrics, and assessments",
        "Cognition of data visualization techniques"
      ],
      mindset: [
        "Focused on task at hand",
        "Adaptable",
        "Patience",
        "Analytical with data",
        "Precise with numbers",
        "Pragmatic",
        "Resourceful",
        "Non-attachment"
      ],
      tools: [
        "Finite Element Modeling Design (FEM)",
        "Finite Modeling Analysis (FMA)",
        "Scripting and parametric modeling"
      ]
    },
    
    // Category 3: Prototype the solution
    2: {
      skills: [
        "Identify the intended function of the prototype",
        "Establish the level of prototyping fidelity",
        "Select and apply prototyping tools",
        "Select and apply prototyping methods and techniques",
        "Select and apply prototyping frameworks",
        "Outline an experimental plan",
        "Determine experiments to perform",
        "Source materials and resources",
        "Produce technical drawings and documents",
        "Produce measurement criteria or metrics",
        "Identify scalable methods of production",
        "Communicate design ideas physically"
      ],
      knowledge: [
        "Cognition of prototypes and functions",
        "Cognition of spatial thinking and visualization",
        "Cognition of prototyping heuristics",
        "Cognition of prototyping methods and techniques",
        "Cognition of prototyping frameworks and canvases",
        "Cognition of the scientific method",
        "Cognition of digital and physical prototyping",
        "Cognition of strategies to source materials and resources",
        "Cognition of technical drawings",
        "Cognition of verification, analysis, and assessment of prototypes",
        "Cognition of product and production",
        "Cognition of design manufacturing and assembly"
      ],
      mindset: [
        "Goal oriented",
        "Optimistic",
        "Empathetic",
        "Out-of-the-box mindset",
        "Pragmatic",
        "Non-attachment"
      ],
      tools: [
        "Simplified Prototyping Strategy",
        "Scaled model",
        "Isolated subsystems model",
        "Rapid prototyping",
        "Additive manufacturing",
        "CAD/CAM manufacturing",
        "CNC routing",
        "Laser cutting",
        "Waterjet cutting",
        "FDM"
      ]
    },
    
    // Category 4: Testing the solution (placeholder based on the document mentioning this as a next step)

  },

  Test : {

    abilities: [
      "Test the solution",
      "Iterative design"
    ],
  
    // Category 1: Test the solution
    0: {
      skills: [
        "Formulate hypothesis",
        "Construct tests and experiments",
        "Conduct tests and experiments",
        "Communicate and engage with the users",
        "Analyze and interpret qualitative data",
        "Analyze and interpret quantitative data",
        "Assess design solutions against conflicting specifications",
        "Assess and manage risks"
      ],
      knowledge: [
        "Cognition of hypothesis formulation",
        "Cognition of scientific and engineering testing methods",
        "Cognition of the scientific method",
        "Cognition of facilitating user-centered testing",
        "Cognition of practical hands-on and real life application",
        "Cognition of existing state of the art solutions",
        "Cognition of failure mode and effect analysis (FMEA)",
        "Cognition of risk assessment and management"
      ],
      mindset: [
        "Reliable",
        "Responsible",
        "Risk taking",
        "Persistent",
        "Resilient",
        "Precise with numbers",
        "Hands-on",
        "Pragmatic with facts"
      ],
      tools: [
        "FMEA"
      ]
    },
    
    // Category 2: Iterative design
    1: {
      skills: [
        "Identify discrepancies in results",
        "Acknowledge mistakes",
        "Acknowledge unproductive pathways",
        "Iterate tests and experiments",
        "Improve the solutions based on iteration",
        "Assess design solutions against conflicting specifications",
        "Assess and manage risks"
      ],
      knowledge: [
        "Cognition of Iterative design",
        "Cognition of iterative prototyping",
        "Cognition of legal requirements",
        "Cognition of corporate policies governing design",
        "Cognition of design of experiments",
        "Cognition of failure mode and effect analysis (FMEA)",
        "Cognition of risk assessment and management"
      ],
      mindset: [
        "Iterative",
        "Reflective",
        "Failure",
        "Non-attachment"
      ],
      tools: [
        "Miro",
        "FigJam"
      ]
    },
    
    // Category 3: Documenting the solution (placeholder based on the document mentioning this as a next step)

  },
  
  Communicate : {

    abilities: [
      "Document the solution",
      "Communicate the solution",
      "Receive feedback"
    ],
  
    // Category 1: Document the solution
    0: {
      skills: [
        "Detail all components of the solution",
        "Produce technical drawings",
        "Evaluate specifications completeness",
        "Assess solution consistency",
        "Validate conformity with relevant standards",
        "Appraise potential improvements of the solution",
        "Provide logistical information (suppliers, references, etc.)",
        "Formulate summary recommendations"
      ],
      knowledge: [
        "Cognition of innovation principles",
        "Cognition of technical drawings and representations",
        "Cognition of design standards and specifications",
        "Cognition of requirements formulation",
        "Cognition of synthesizing the conducted design process",
        "Cognition of business communication",
        "Cognition of logistic systems"
      ],
      mindset: [
        "Analytical",
        "Detail oriented",
        "Focused on tasks",
        "Organized with information",
        "Precise with facts",
        "Credible"
      ],
      tools: [
        "Miro",
        "FigJam",
        "Notion"
      ]
    },
    
    // Category 2: Communicate the solution
    1: {
      skills: [
        "Identify the audience",
        "Construct relationships among ideas",
        "Prepare logical arguments",
        "Build persuasive arguments",
        "Determine the appropriate media",
        "Provide relevant, credible, and accurate supporting information",
        "Express succinct, precise, and concise language",
        "Follow time instructions effectively",
        "Carry out Q&A efficiently and effectively"
      ],
      knowledge: [
        "Cognition of business acumen for presentations",
        "Cognition of story telling",
        "Cognition of design narratives",
        "Cognition of techniques to pitch and present",
        "Cognition of type of audience and expectations",
        "Cognition of data collection and analysis",
        "Cognition of technical jargon",
        "Cognition of estimating, time, budget, and resources"
      ],
      mindset: [
        "Confident",
        "Eloquence",
        "Scientific",
        "Artistic",
        "Credible",
        "Empathetic",
        "Enthusiastic",
        "Expressive"
      ],
      tools: [
        "Story boarding",
        "Elevator pitch"
      ]
    },
    
    // Category 3: Receive feedback
    2: {
      skills: [
        "Listen thoroughly",
        "Ask thoughtful questions",
        "Communicate and engage with customer/user",
        "Communicate and engage with the team",
        "Apply professional behaviour",
        "Process received feedback",
        "Reflect and summarize received feedback"
      ],
      knowledge: [
        "Cognition of psychological user behaviour patterns",
        "Cognition of sociological principles on behaviour",
        "Cognition of techniques on processing feedback",
        "Cognition of evaluation and metrics",
        "Cognition of professional ethics (integrity and accountability)"
      ],
      mindset: [
        "Receptive to criticism",
        "Open to ideas",
        "Open to differing opinions",
        "Accept change",
        "Emotionally rugged"
      ],
      tools: []
    }
  }




};

export default data;